import React from "react";
import { View, Text, StyleSheet } from "react-native"
import { getRolename } from "../../../functions";
import { SuccessAvatar, DailyprogressAvatar } from "../../Image";
import { PrimaryCaption, PrimaryTitle } from "../../labels";

export default function MemberProgress({ item }) {
    const { id, nickname, role_type, task_status, riddle_status } = item
    let userRole = getRolename(role_type);

    return (
        <View style={styles.item}>
            <View style={{ flex: 0.8 }}>
                <PrimaryTitle size={15}>
                    {nickname}
                </PrimaryTitle>
                <PrimaryCaption>
                    {userRole}
                </PrimaryCaption>
            </View>
            <View style={{ flex: 0.2 }}>
                {
                    task_status === 1 ? <SuccessAvatar size={36} /> : <DailyprogressAvatar size={36} />
                }
            </View>
            <View style={{ flex: 0.2 }}>
                {
                    riddle_status === 1 ? <SuccessAvatar size={36} /> : <DailyprogressAvatar size={36} />
                }
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    item: {
        paddingVertical: 8,
        flexDirection: "row"
    }
})